import React from "react";
import { embedConverter } from "../embed-converter.js";
import { EmbedViewer } from "../viewer/embed-viewer.js";
const Embed = ({ settings, node }) => {
  const ricosNode = React.useMemo(() => embedConverter.fromPm.convert(node.toJSON()), [node]);
  return /* @__PURE__ */ React.createElement(
    EmbedViewer,
    {
      node: ricosNode,
      settings,
      iframeSandboxDomain: ""
    }
  );
};
export {
  Embed
};
//# sourceMappingURL=embed.js.map
